import apiClient from './api';

export interface Media {
  mediaId: string;
  url?: string;
  path?: string;
  type: 'audio' | 'video' | 'image';
  createdAt: Date;
}

export interface GetMediaParams {
  markerId?: string;
  type?: string;
}

export const mediaService = {
  getMediaById: async (mediaId: string): Promise<Media> => {
    const response = await apiClient.get<Media>(`/api/media/${mediaId}`);
    return response.data;
  },

  getMedia: async (params?: GetMediaParams): Promise<Media[]> => {
    const response = await apiClient.get<Media[]>('/api/media', { params });
    return response.data;
  },

  uploadMedia: async (file: File, metadata?: { type?: string }): Promise<Media> => {
    const formData = new FormData();
    formData.append('file', file);
    if (metadata?.type) formData.append('type', metadata.type);
    const response = await apiClient.post<Media>('/api/media/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  linkMedia: async (mediaId: string, markerId: string, field: string, language: string): Promise<void> => {
    await apiClient.post(`/api/media/${mediaId}/link`, { markerId, field, language });
  },

  unlinkMedia: async (mediaId: string, markerId: string, language: string): Promise<void> => {
    await apiClient.post(`/api/media/${mediaId}/unlink`, { markerId, language });
  },

  deleteMedia: async (mediaId: string): Promise<void> => {
    await apiClient.delete(`/api/media/${mediaId}`);
  },
};
